import { StudyStatus } from '@asset/enum/studyStatus';
import { getStudentStudyStatusText } from '@asset/function/commonFunctions';
import BasicArrowTooltip from '@components/common/tool-tip/BasicArrowTooltip';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export const StudyStatusLight = ({
  studyStatus
}) => {
  const statusColor = studyStatus === StudyStatus.ACTIVE ? 'var(--green-50)' : studyStatus === StudyStatus.INACTIVE ? 'var(--gray-70)' : 'var(--red-50)';
  return /*#__PURE__*/_jsx("div", {
    className: `min-w-[0.5rem] min-h-2 w-2 h-2 rounded-full`,
    style: {
      background: statusColor
    }
  });
};
const StudyStatusIndicator = ({
  studyStatus,
  studyCompletedAt,
  elapsedTime,
  studyItemType,
  tooltipTitle,
  onClickTooltip
}) => {
  const {
    timeText,
    statusText
  } = getStudentStudyStatusText({
    solvedAt: studyCompletedAt,
    elapsedTime,
    studyItemType
  });
  return /*#__PURE__*/_jsxs("div", {
    className: "flex items-center gap-1",
    children: [/*#__PURE__*/_jsx(StudyStatusLight, {
      studyStatus: studyStatus
    }), /*#__PURE__*/_jsxs("div", {
      className: `text-label-sm-500 text-my-gray-50 whitespace-nowrap`,
      children: [timeText, "\xA0", statusText && '-', "\xA0"]
    }), /*#__PURE__*/_jsx(BasicArrowTooltip, {
      arrow: true,
      placement: "top",
      title: tooltipTitle ?? '',
      disableHoverListener: tooltipTitle === null,
      children: /*#__PURE__*/_jsx("div", {
        className: `relative underline cursor-pointer text-label-sm-500 text-my-blue-50 break-keep`,
        onClick: onClickTooltip,
        children: statusText
      })
    })]
  });
};
export default StudyStatusIndicator;